const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color-grid_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m384.73,45.45c-2.32-2.32-5.52-3.64-8.8-3.64H54.06c-3.27,0-6.48,1.33-8.8,3.64s-3.64,5.52-3.64,8.8v321.5c0,3.28,1.33,6.48,3.64,8.8,2.32,2.32,5.52,3.64,8.8,3.64h321.88c3.27,0,6.48-1.33,8.79-3.64,2.32-2.31,3.64-5.52,3.64-8.8V54.25c0-3.28-1.33-6.48-3.64-8.8Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.12,
    y: 280.88,
    width: 83.75,
    height: 82.43,
    style: {
      fill: "#777"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.12,
    y: 173.12,
    width: 83.75,
    height: 83.75,
    style: {
      fill: "#0063f7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 173.12,
    width: 82.62,
    height: 83.75,
    style: {
      fill: "#60c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.12,
    y: 66.69,
    width: 83.75,
    height: 82.43,
    style: {
      fill: "#f80"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.88,
    y: 173.12,
    width: 82.62,
    height: 83.75,
    style: {
      fill: "#06c270"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.88,
    y: 66.69,
    width: 82.62,
    height: 82.43,
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 66.69,
    width: 82.62,
    height: 82.43,
    style: {
      fill: "#ff3b3b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 280.88,
    width: 82.62,
    height: 82.43,
    style: {
      fill: "#171717"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.88,
    y: 280.88,
    width: 82.62,
    height: 82.43,
    style: {
      fill: "#c7c7c7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorGrid);
export default __webpack_public_path__ + "static/media/color-grid.c1fedf7154db5076cea0d8728d6fdfc6.svg";
export { ForwardRef as ReactComponent };